"use strict";

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _DropdownMenu = _interopRequireDefault(require("./components/DropdownMenu"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable react/jsx-no-bind */

var drawerWidth = 240;
var NavBar = function NavBar(_ref) {
  var classes = _ref.classes,
    isSidebarOpened = _ref.isSidebarOpened,
    navBarData = _ref.navBarData,
    navBarCartData = _ref.navBarCartData,
    navBarstyling = _ref.navBarstyling,
    numberOfCases = _ref.numberOfCases,
    _ref$components = _ref.components,
    components = _ref$components === void 0 ? {} : _ref$components,
    externalLinksFlag = _ref.externalLinksFlag,
    externalLinks = _ref.externalLinks,
    LoginComponent = _ref.LoginComponent; // Similar to componentDidMount and componentDidUpdate:
  // Empty second argument of react useEffect will avoid the infinte loop that
  // caused due to component update
  var _react$default$useSta = _react.default.useState(null),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    clickedEl = _react$default$useSta2[0],
    setClickedEl = _react$default$useSta2[1];
  function handleButtonClickEvent(eventName) {
    setClickedEl(eventName);
  }
  var getCartLabel = function getCartLabel(labelType) {
    switch (labelType) {
      case 'labelUnderCount':
        return /*#__PURE__*/_react.default.createElement("div", {
          className: classes.cartCounter2Wrapper
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: classes.cartCounter2
        }, numberOfCases), /*#__PURE__*/_react.default.createElement("div", {
          className: classes.cartLabel
        }, "Files"));
      default:
        return /*#__PURE__*/_react.default.createElement("span", {
          className: classes.badge
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: classes.cartCounter
        }, numberOfCases));
    }
  };
  var Tooltip = components.Tooltip || _core.Tooltip;
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "fixed",
    className: (0, _classnames.default)(classes.appBar, _defineProperty({}, classes.appBarShift, isSidebarOpened))
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "navbar",
    className: classes.buttonContainer
  }, navBarData.slice(0, 7).map(function (navButton, index) {
    return navButton.type === 'dropdown' ? /*#__PURE__*/_react.default.createElement(_DropdownMenu.default, {
      handleButtonClickEvent: handleButtonClickEvent,
      clickedEl: clickedEl,
      index: index,
      linkText: navButton.labelText,
      dropDownElements: navButton.dropDownLinks.slice(0, 9),
      navBarstyling: navBarstyling,
      externalLinksFlag: externalLinksFlag,
      externalLinks: externalLinks
    }) : /*#__PURE__*/_react.default.createElement(_core.Box, {
      id: "button_navbar_navButton_".concat(index),
      className: classes.logotype,
      classes: {
        root: classes.buttonRoot
      }
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.HashRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
      className: classes.labelText,
      activeClassName: classes.activeLabel,
      to: navButton.link ? navButton.link : '/',
      onClick: function onClick() {
        return handleButtonClickEvent("".concat(navButton.labelText));
      }
    }, navButton.labelText)));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.myCasesPosition
  }, /*#__PURE__*/_react.default.createElement(LoginComponent, null), navBarCartData && /*#__PURE__*/_react.default.createElement(_core.Box, {
    id: "button_navbar_mycases",
    className: classes.logotype,
    classes: {
      root: classes.buttonRootNoRightPadding
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.HashRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    className: classes.cartLabelText,
    to: navBarCartData.cartLink
  }, navBarCartData.cartLabel, /*#__PURE__*/_react.default.createElement(Tooltip, {
    title: "Files",
    placement: "bottom-end"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.badge
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: classes.cartIcon,
    src: navBarCartData.cartIcon,
    alt: navBarCartData.cartIconAlt
  }), getCartLabel(navBarCartData.cartLabelType)))))))));
};
var styles = function styles() {
  return {
    myCasesPosition: {
      position: 'absolute',
      right: '20px'
    },
    logotype: function logotype(props) {
      return {
        whiteSpace: 'nowrap',
        color: '#FFFFFF',
        fontFamily: props.navBarstyling.global.fontFamily ? props.navBarstyling.global.fontFamily : 'Raleway',
        fontSize: '11px',
        letterSpacing: props.navBarstyling.global.letterSpacing ? props.navBarstyling.global.letterSpacing : '1.25px',
        fontWeight: props.navBarstyling.global.fontWeight ? props.navBarstyling.global.fontWeight : '800',
        '&:hover, &:focus': {
          borderRadius: '0'
        }
      };
    },
    buttonContainer: {
      margin: '0 auto'
    },
    appBar: function appBar(props) {
      return {
        backgroundColor: props.navBarstyling.global.backgroundColor ? props.navBarstyling.global.backgroundColor : '#142D64',
        marginTop: props.navBarstyling.global.marginTop ? props.navBarstyling.global.marginTop : '100px',
        width: '100vw'
      };
    },
    cartIcon: function cartIcon(props) {
      return {
        height: props.navBarstyling.cart && props.navBarstyling.cart.iconSize ? props.navBarstyling.cart.iconSize : '22px',
        margin: '0px 0px 0px 6px'
      };
    },
    labelText: function labelText(props) {
      return {
        textDecoration: 'none',
        color: props.navBarstyling.global.fontColor ? props.navBarstyling.global.fontColor : '#FFFFFF',
        fontFamily: props.navBarstyling.global.fontFamily ? props.navBarstyling.global.fontFamily : 'Nunito',
        fontSize: '13px'
      };
    },
    cartLabelText: function cartLabelText(props) {
      return {
        textDecoration: 'none',
        color: props.navBarstyling.global.fontColor ? props.navBarstyling.global.fontColor : '#FFFFFF',
        fontFamily: props.navBarstyling.global.fontFamily ? props.navBarstyling.global.fontFamily : 'Nunito',
        textTransform: props.navBarstyling.global.textTransform ? props.navBarstyling.global.textTransform : 'UPPERCASE',
        fontSize: '13px'
      };
    },
    activeLabel: function activeLabel(props) {
      return {
        borderBottom: props.navBarstyling.global.activeLabel ? props.navBarstyling.global.activeLabel : '1px solid  #FFFFFF'
      };
    },
    appBarShift: {
      paddingRight: '0px !important',
      width: '100%',
      marginLeft: drawerWidth
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0
    },
    toolbar: function toolbar(props) {
      return {
        minHeight: props.navBarstyling.global.height ? props.navBarstyling.global.height : '39px',
        paddingRight: props.navBarstyling.global.paddingRight ? props.navBarstyling.global.paddingRight : '45px',
        paddingLeft: props.navBarstyling.global.paddingLeft ? props.navBarstyling.global.paddingLeft : '45px',
        alignItems: 'flex-start'
      };
    },
    buttonRoot: function buttonRoot(props) {
      return {
        padding: props.navBarstyling.global.padding ? props.navBarstyling.global.padding : '9px 20px 0px 20px',
        border: '0',
        cursor: 'pointer',
        margin: '0',
        display: 'inline-flex',
        position: 'relative',
        alignItems: 'center',
        verticalAlign: 'middle',
        justifyContent: 'center',
        textDecoration: 'none',
        backgroundColor: 'transparent',
        textTransform: 'uppercase',
        lineHeight: '1.75'
      };
    },
    buttonRootNoRightPadding: function buttonRootNoRightPadding(props) {
      return {
        padding: props.navBarstyling.cart.padding || props.navBarstyling.global.padding || '9px 20px 0px 20px',
        border: '0',
        cursor: 'pointer',
        margin: '0',
        display: 'inline-flex',
        position: 'relative',
        alignItems: 'center',
        verticalAlign: 'middle',
        justifyContent: 'center',
        textDecoration: 'none',
        backgroundColor: 'transparent',
        textTransform: 'uppercase',
        lineHeight: '1.75'
      };
    },
    badge: {
      display: 'inline-flex',
      position: 'relative',
      verticalAlign: 'middle'
    },
    cartCounter: {
      height: '16px',
      minWidth: '16px',
      fontFamily: 'inter',
      fontWeight: '600',
      letterSpacing: '0.8px',
      transform: 'scale(1) translate(0%, -50%)'
    },
    cartCounter2Wrapper: {
      marginTop: '-6px',
      marginLeft: '6px'
    },
    cartCounter2: {
      height: '16px',
      minWidth: '16px',
      fontFamily: 'Lato',
      fontWeight: '600',
      letterSpacing: '0.8px',
      textAlign: 'start',
      fontSize: '12px'
    },
    cartLabel: function cartLabel(props) {
      return {
        height: '16px',
        minWidth: '16px',
        color: props.navBarstyling.cartLabel && props.navBarstyling.cartLabel.color ? props.navBarstyling.cartLabel.color : '#24E4BE',
        fontFamily: 'Raleway',
        fontWeight: '600',
        letterSpacing: '0.8px',
        textAlign: 'start',
        fontSize: '12px'
      };
    },
    iconButtonRoot: {
      paddingTop: '9px',
      paddingLeft: '0px'
    },
    floatRight: {
      float: 'right'
    },
    floatLeft: {
      float: 'left',
      marginTop: '6px',
      marginLeft: '10px'
    },
    funnelLogoImg: {
      width: '20px',
      height: '20px'
    },
    clearAllButtonRoot: {
      margin: 'auto'
    },
    customButton: {
      borderRadius: '100px',
      borderLeft: '0px',
      minHeight: '20px',
      fontSize: 9,
      textTransform: 'none',
      color: 'black',
      marginLeft: '16px',
      // fontFamily: theme.custom.fontFamilySans,
      '&:hover': {
        backgroundColor: '#566672',
        color: 'white'
      }
    },
    drawerAppBar: {
      height: '45px'
    },
    drawerPaper: {
      width: drawerWidth,
      marginTop: '100px',
      zIndex: '1201',
      height: 'calc(100% - 100px)'
    }
    // headerMenuButton: {
    //   marginLeft: theme.spacing.unit,
    //   padding: theme.spacing.unit / 2,
    // },
  };
};

NavBar.defaultProps = {
  classes: {},
  navBarstyling: {},
  LoginComponent: function LoginComponent() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
};
var StyledNavBar = (0, _core.withStyles)(styles)(NavBar);
var _default = StyledNavBar;
exports.default = _default;